import { Button, Form } from 'antd';
import { Input } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment';
import React, { ReactElement, useEffect } from 'react';
import RangeDatePicker from '../../../shared/components/DatePicker/RangeDatePicker';
import FormModal from '../../../shared/components/modal/FormModal';
import { DATE_FORMAT } from '../../../shared/constants/commonConstants';
import { PROFILE_SAVECALENDAR } from '../../../shared/constants/urlEndPoints';
import { SaveCalendarRequest, SaveCalendarResponse } from '../../../shared/models/hospitalProfile.model';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import SendRequest from '../../../shared/services/sendRequest.service';
import { error, success } from '../../../utils/utility';

const AddCalendarForm = ({ visible, onCancel, onOk, title, data, eventId, defaultDate }: any): ReactElement => {
  const [form] = Form.useForm();
  const { name: eventName, description: desc, department: dprtmnt, startDateTime, endDateTime } = data || {} as any;
  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  useEffect((): void => {
    if (data) {
      form.setFieldsValue({
        eventName,
        description: desc,
        department: dprtmnt,
      });
    }
    // eslint-disable-next-line
  }, [form.getFieldsValue().eventName]);

  useEffect((): any => {
    getDefaultValue();
  }, []);

  const onSaveCalendar = (): void => {
    const { eventName: name, date, department, description }: any = form.getFieldsValue();

    saveCalendar({
      name, start: moment(date[0]._d).format('YYYY-MM-DD HH:mm:ss'), end: moment(date[1]._d).format('YYYY-MM-DD HH:mm:ss'),
      department,
      description,
      id: eventId || undefined,
      isActive: true,
    });
  };

  const saveCalendar = async ({ name, start, end, department, description, id, isActive }: any): Promise<any> => {
    const saveUrl = `${process.env.REACT_APP_BASE_URL}${PROFILE_SAVECALENDAR}`;
    const payload: SaveCalendarRequest = {
      applicationId: 123456,
      calendar: [
        {
          profileId: ApplicationDetail.instance.getProfileId(),
          typeId: 1,
          name,
          description: description || 'NA',
          department: department || 'NA',
          fullAddress: '',
          startDateTime: start,
          startTime: 650,
          endTime: 800,
          endDateTime: end,
          isActive,
          statusId: 1,
          id,
          typeName: 'HospitalProfile',
        },
      ],
    };
    const res: SaveCalendarResponse = await SendRequest.instance.post<any, any>(saveUrl, payload);
    if (res && res.isSuccess) {
      onOk();
      success(`Event ${data && isActive ? 'updated' : !isActive ? 'deleted' : 'saved'} successfully!`);
    } else {
      error(`Couldn't ${data && isActive ? 'update' : !isActive ? 'delete' : 'save'} event, please try again.`);
    }
  };

  const getDefaultValue = (): void => {
    let date: any = null;
    if (data) {
      date = [moment(new Date(startDateTime), DATE_FORMAT), moment(new Date(endDateTime), DATE_FORMAT)];
    } else if (defaultDate) {
      date = [moment(defaultDate.start, DATE_FORMAT),
      moment(
        moment(defaultDate.start).isSame(defaultDate.end, 'h') && moment(defaultDate.start).isSame(defaultDate.end, 'm') ?
          moment(defaultDate.end).add(1, 'minute') : moment(defaultDate.end), DATE_FORMAT,
      ),
      ];
    } else {
      date = null;
    }
    form.setFieldsValue({ date });
  };

  const onRemoveEvent = (): void => {
    saveCalendar({
      name: eventName, start: startDateTime, end: endDateTime,
      department: dprtmnt,
      description: desc,
      id: eventId,
      isActive: false,
    });
  };

  return (
    <>
      <FormModal visible={visible} onCancel={onCancel} title={title} isFooter={false}>
        {form && (
          <Form form={form} autoComplete={'off'}
            {...layout}
            name="basic"
            onFinish={onSaveCalendar}
          >
            <Form.Item label="Select date"
              name="date"
              rules={[{ required: true, message: 'Please select event date!' }]}
            >
              <RangeDatePicker bordered={false} placeholder={['Start date & time', 'End date & time']} size={'small'} />
            </Form.Item>
            <Form.Item
              label="Event name"
              name="eventName"
              rules={[{ required: true, message: 'Please enter event name!' }]}
            >
              <Input placeholder="Event name" />
            </Form.Item>
            <Form.Item
              label="Description"
              name="description"
              rules={[{ required: true, message: 'Please enter description!' }]}
            >
              <TextArea placeholder="Description" />
            </Form.Item>
            <Form.Item
              label="Department"
              name="department"
              rules={[{ required: false }]}
            >
              <Input placeholder="Department" />
            </Form.Item>
            <Form.Item className="text-right mb-0">
              {data && (
                <Button type="default" className="mr-10" onClick={onRemoveEvent}>
                  Delete
                </Button>
              )}
              <Button type="primary" htmlType="submit">
                {data ? 'Update' : 'Save'}
              </Button>
            </Form.Item>
          </Form>
        )}
      </FormModal>
    </>
  );
};

export default AddCalendarForm;
